var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("You have reached the login page.")]),(! _vm.userSession.isUserSignedIn())?_c('landing'):_c('div',[_vm._v("User already logged in")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }